import { Radio, RadioProps } from 'antd';
import classNames from 'classnames';
import React from 'react';
import './style.scss';

interface IBaseProps {
  /** Class name of the component  */
  className?: string;
}

interface IProps extends IBaseProps, Omit<RadioProps, 'onChange'> {
  /** Inner class name of component */
  className?: string;
  /** Name of component */
  name: string;
  /** The callback function that is triggered when the state changes */
  onChange?: (name: string, value: any) => void;
  disabled?: boolean;
}

const CustomRadio = ({
  onChange: onChangeProp = () => {},
  className = '',
  disabled = false,
  name,
  ...props
}: IProps): React.JSX.Element => {
  /**
   * Reports a radio selection to the caller together with the group name. Passes name and e.target.value to the optional onChange prop, skipping the call when none was supplied.
   *
   * @param e - The radio change event.
   * @returns Nothing.
   */
  const onChange = (e: any) => {
    onChangeProp?.(name, e.target.value);
  };

  return (
    <Radio
      {...props}
      name={name}
      disabled={disabled}
      className={classNames('custom-radio-wrapper', className)}
      onChange={onChange}
    />
  );
};

export default CustomRadio;
